import React, {Fragment} from "react";
import {Box} from "@mui/material";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import {useTranslation} from "react-i18next";

const DatasetAttachments = ({datasetTitle, attachedDataFiles}) => {
  const {t} = useTranslation();

  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          "& > .MuiChip-root": {
            margin: "4px"
          },
          "& > .MuiChip-root:first-child": {
            marginLeft: 0
          },
          "& > .MuiChip-root:focus": {
            outline: "-webkit-focus-ring-color auto 1px"
          }
        }}
      >
        {(attachedDataFiles || []).map(({format, url}, idx) => {
          const name = url.split("/").pop();
          return (
            <Tooltip key={idx} title={name}>
              <Chip
                className={`download-btn--${format.toLowerCase()}`}
                label={name}
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  window.open(url, "_blank");
                }}
                sx={{
                  cursor: "pointer",
                  backgroundColor: theme => theme.palette.primary.main,
                  color: theme => theme.palette.primary.contrastText,
                  "&:hover": {
                    backgroundColor: theme => theme.palette.primary.light,
                    color: theme => theme.palette.primary.contrastText
                  }
                }}
                aria-label={t("scenes.results.datasetCard.downloadAria", {
                  title: datasetTitle,
                  extension: format
                })}
              />
            </Tooltip>
          );
        })}
      </Box>
    </Fragment>
  );
};

export default DatasetAttachments;
